import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="clipboard"
export default class extends Controller {
  static targets = ["source"]

  copy(event) {
    const button = event.currentTarget
    const sourceId = button.dataset.clipboardSourceParam
    const sourceElement = document.getElementById(sourceId)
    
    if (!sourceElement) {
      console.error(`Element with id '${sourceId}' not found`)
      return
    }

    const text = sourceElement.textContent.trim()
    
    // Try modern Clipboard API first
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(text)
        .then(() => this.showSuccess(button))
        .catch((err) => this.copyFallback(text, button, err))
    } else {
      this.copyFallback(text, button)
    }
  }

  copyFallback(text, button, previousError = null) {
    try {
      const textarea = document.createElement('textarea')
      textarea.value = text
      textarea.style.position = 'fixed'
      textarea.style.opacity = '0'
      document.body.appendChild(textarea)
      textarea.select()
      const successful = document.execCommand('copy')
      document.body.removeChild(textarea)
      
      if (successful) {
        this.showSuccess(button)
      } else {
        this.showError(button, new Error('execCommand copy failed'))
      }
    } catch (err) {
      this.showError(button, err)
    }
  }

  showSuccess(button) {
    const originalHTML = button.innerHTML
    button.innerHTML = '<svg class="w-4 h-4 mr-2" fill="currentColor" viewBox="0 0 20 20"><path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd"></path></svg>Copied!'
    
    setTimeout(() => {
      button.innerHTML = originalHTML
    }, 2000)
  }

  showError(button, err) {
    console.error('Failed to copy:', err)
    const originalHTML = button.innerHTML
    button.innerHTML = '<svg class="w-4 h-4 mr-2" fill="currentColor" viewBox="0 0 20 20"><path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clip-rule="evenodd"></path></svg>Failed'
    
    setTimeout(() => {
      button.innerHTML = originalHTML
    }, 2000)
  }
}
